import { profiles } from "../data"
import graphicsImg from "../assets/graphics-wip.png"

function Contents(props: any) {
    const profile = profiles[props?.index];
    var element;
    if (profile && profile.type) {
        element = (
            <div className={profile.id + " contents"}>
                <h1>{profile.title}</h1>
                <p>{profile.description}</p>
                { profile.type === "list" && <ul>
                        {
                            profile.links?.map(function(article: any, index: number) {
                                var title = article.dataViz ? article.title + " *" : article.title;
                                return (
                                    <li>
                                        <a href={article.url} key={index}>{title}</a>
                                    </li>
                                )
                            })
                        }
                    </ul> 
                }
                { profile.id === "words" && <p>* includes data visualizations!</p> }
                { profile.type === "img-list" && <img alt="Collection of graphics arranged in a circle." src={graphicsImg}></img>}
            </div>
        )
        return element;
        
    } else {
        return <div></div>
    }
}
    
 export default Contents